import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <p>
              © 2024 ProCam360 | <a href="aviso-de-privacidad">Aviso de privacidad</a> |{' '}
              <a href="terminos-de-pago-electronico">Términos de Pago Electrónico</a>
            </p>
          </div>
          <div className="social-links">
            <a
              href="https://www.facebook.com/procam360mx"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://instagram.com/procam360mx"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://tiktok.com/@procam360mx"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
